import { Injectable } from '@angular/core';
import { UserSession } from '@mem-shared/user-session';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ModalOptions } from 'ngx-bootstrap/modal';
import { UtilService } from './util.service';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { environment } from '../../environments/environment';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { MemberAuditRequest } from './audit/memberAudit.model';
import { map } from 'rxjs/operators';
import { EventService } from '@mem-shared/event.service';





declare let AndroidPortalApp: any;
const memberAuditUrl = '/mas/pub/memberAudit.json';
declare let ga: Function;
declare let fap;

@Injectable()
export class NativeIntegrationService {
  private targetURL: string;
  isIdCardSaved: boolean;
  checkIdCardFlow: boolean;
  userInOfflineMode: boolean;
  nativeCardSavedPromise: any[];
  localPath: string;

  noOfIdCards: number;
  timeStamp: string;
  callFaceTouchTermsRef: BsModalRef;
  // PreLogin touch start
  isPreLoginTouch = null;
  isNativeTouch = null;
  getUsrPwd = null;

  loggingInPassword: string;
  loggingInUserName: string;
  //sd params
  pcpid: any;
  firstname: any;
  lastname: any;
  middleinitial: any;
  sapphire_provider_id: any;
  sapphire_location_id: any;
  gender: any;
  phoneNumber: any;
  address1: any;
  city: any;
  state: any;
  zip: any;
  pcpData;
  sdContext;
  ///

  deeplinkName: string;

  //
  private isIdCardSaved1 = new BehaviorSubject(false);
  private isIdCardSaved1$: Observable<boolean>;

  // PreLogin touch end
  constructor(
    private userSession: UserSession,
    private router: Router,
    private utilService: UtilService,
    private modalService: BsModalService,
    private http: HttpClient,
    private eventService: EventService



  ) {
    //console.log('native service');
    this.isIdCardSaved1$ = this.isIdCardSaved1.asObservable();
    //alert('In Native service call');
    this.bindExternalCallFromNative();
  }

  /**
   * SBS is looking for some additional headers
   * See SBS code:
   * MemberWeb/src/main/com/carefirst/member/present/filters/MemberAuthenticationFilter.java
   */
  protected setHeaders(existingHeaders?) {
    return new HttpHeaders()
      .set('nativeOS', this.utilService.getNativeOS())
      .set('device', this.utilService.getDeviceType());
  }

  post(url, body?, httpOptions?): Observable<any> {
    /**
     * Allows application services to send cf-http raw javascript objects.
     * for form-urlencoded cf-http will create the query string
     * for form data cf-http will create the form data object
     */
    if (this.hasHeader(httpOptions, 'Content-Type', 'application/x-www-form-urlencoded') ||
      this.hasHeader(httpOptions, 'Content-Type', 'application/pdf')) {
      body = this.mapRequestData(body, 'urlencoded').toString();
    } else if (this.hasHeader(httpOptions, 'enctype', 'multipart/form-data')) {
      body = this.mapRequestData(body, 'formdata');
    }
    return this.http
      .post(this.getAbsoluteURL(url), body, httpOptions)
      .pipe(map(this.checkCfResponse));
  }

  private hasHeader(httpOptions, header, value) {
    if (httpOptions && httpOptions.headers) {
      return httpOptions.headers.get(header) === value;
    } else {
      return false;
    }
  }

  /**
   * CF Response always returns
   * 200 status so we have to
   * check the success value
   */
  private checkCfResponse(res) {
    if (res.responseContext) {
      if (!res.responseContext.success) {
        throw res;
      }
    }
    return res;
  }

  public getAbsoluteURL(url: string) {
    let baseUrl;
    if (this.targetURL === undefined) {
      const nativeOS = this.utilService.getNativeOS();

      if (nativeOS !== 'web') {
        this.invokeNativeService(nativeOS, 'checkTargetLink', null);
        //console.log('native target is: ' + this.nativeService.getTargetURL());
        baseUrl = this.getTargetURL();
      } else {
        baseUrl = location.origin;
      }
      this.targetURL = baseUrl;
      //console.log('absolute url is: ' + baseUrl);
    }

    // if the url is already absolute just return it
    if (url.includes('http')) {
      return url;
    } else {
      return this.targetURL + url;
    }
  }
  /**
 * Maps an object to an HttpParams or FormData construct.
 * x-wwww-form-urlencoded also uses the HTTPParams since
 * HttpParams eseentially provides the query string format
 * which is exactaly what x-www-form-urlencoded is looking for.
 *
 * @param params parameters to map
 * @param type the type to map to. params or formdata
 */
  private mapRequestData(data, format: 'formdata' | 'params' | 'urlencoded' | 'json') {
    let mappedData;

    switch (format) {
      case 'formdata':
        mappedData = new FormData();
        break;
      case 'urlencoded':
      case 'params':
        mappedData = new HttpParams();
        break;
      default:
        return data;
    }

    for (const k in data) {
      if (data.hasOwnProperty(k)) {
        // funky code block here because FormData's set method
        // is muttable and returns undefined where HttpParams
        // is imutable and returns a new object with the
        // added/updated param.
        mappedData = mappedData.set(k, data[k]) || mappedData;
      }
    }

    return mappedData;
  }

  public invokeNativeService(nativeOS: 'iOS' | 'Android' | 'web', method, parameters) {
    //alert('in invoke service');
    if (nativeOS === 'iOS') {
      console.log('invoking ios ' + method + '*****' + parameters);
      // alert('method name')
      // alert(method)
      // alert('in invoke service parameter');
      // alert(parameters)
      this.invokeNativeiOS(method, parameters);
    } else if (nativeOS === 'Android') {
      console.log('invoking android ' + method + '*****' + parameters);
      this.invokeNativeAndroid(method, parameters);
    }
  }

  public nativeIsIdCardSaved(
    nativeOS: 'iOS' | 'Android' | 'web',
    method,
    parameters
  ): Observable<boolean> {
    //console.log("nativeIsIdCardSaved start ");
    this.invokeNativeService(nativeOS, method, parameters);
    //console.log("nativeIsIdCardSaved end this.isIdCardSaved1$ ==="+this.isIdCardSaved1$);
    return this.isIdCardSaved1$;
  }
  //Adding the fourth optional param 'nativename' to pass the Dynamic method in invokeNative Function
  public openPDFInNativeApp(nativeOS, url, parameters?, nativeName?) {
    var final_URL = '';
    if (url.indexOf('carefirst.com') < 0) {
      final_URL = this.getTargetURL() + url + '?' + parameters;
    }
    else {
      final_URL = url + '?' + parameters;
    }
    // var final_URL = this.getTargetURL() + url + '?' + parameters; 
    //var final_URL = url + '?' + parameters; //Remove the this.getTargetURL() 

    if (nativeName === null || nativeName === undefined) {
      if (nativeOS === 'iOS') {
        //  alert(final_URL);
        this.invokeNativeiOS('openFile', final_URL);
      } else if (nativeOS === 'Android') {
        // alert("URL " +url  )
        this.invokeNativeAndroid('openFile', decodeURIComponent(final_URL));
      }
    } else {
      //Here we will pass the nativeName as  method for
      if (nativeOS === 'iOS') {
        this.invokeNativeiOS(nativeName, final_URL);
      } else if (nativeOS === 'Android') {
        // alert("URL " +url  )
        this.invokeNativeAndroid(nativeName, decodeURIComponent(final_URL));
      }
    }
  }

  private invokeNativeiOS(method, parameters) {
    let url = 'objc::' + method + '(';
    if (parameters !== null) {
      url = url + parameters;
    }
    url = url + ')';
    console.log('invokeNativeiOS ' + url);
    let iframe = document.createElement('IFRAME');
    iframe.setAttribute('src', url);
    document.documentElement.appendChild(iframe);
    iframe.parentNode.removeChild(iframe);
    iframe = null;
  }

  private invokeNativeAndroid(method, parameters) {
    console.log('invokeNativeAndroid' + method + parameters);
    if (parameters === null || parameters === '') {
      //Android-Touch
      AndroidPortalApp[method]();
    } else {
      console.log('else' + parameters);
      AndroidPortalApp[method](parameters);
    }
  }

  openUrl(url) {
    const nativeOS = this.utilService.getNativeOS();
    this.invokeNativeService(nativeOS, 'checkTargetLink', null);
    let origin = this.getTargetURL();
    if (url.indexOf('http') === -1 && url.indexOf('www') === -1 && url.indexOf('https') === -1) {
      url = origin + url;
    } else if (url.indexOf('identityProtectionTransfer') !== -1) {
      url = origin + url;
    }
    /* if(url.indexOf("content.carefirst.com") === -1){
      url = origin+url;
    }  */
    if (this.utilService.getNativeOS() === 'Android')
      this.invokeNativeAndroid('clickFunctionalityOuter', url);
    else this.invokeNativeiOS('clickFunctionalityOuter', url);
  }

  public setSavedIDCardsData(localPath, noOfIdCards, timeStamp) {
    //console.log("inside setSavedIDCardsData method start")
    this.localPath = localPath;
    this.noOfIdCards = parseInt(noOfIdCards);
    this.timeStamp = timeStamp;
    if (
      this.localPath &&
      this.localPath !== 'null' &&
      this.localPath !== '' &&
      this.noOfIdCards &&
      this.noOfIdCards !== 0 &&
      this.timeStamp &&
      this.timeStamp !== '' &&
      this.timeStamp !== 'null'
    ) {
      this.isIdCardSaved = true;
    } else {
      this.isIdCardSaved = false;
    }
    //console.log("inside setSavedIDCardsData method end isIdCardSaved ===="+this.isIdCardSaved)
  }

  private setTargetURL(targetURL) {
    this.targetURL = targetURL;
    console.log('*******in set Target url*******' + targetURL)
    // alert("kunal:native-integration-service:Target URL set:" + this.targetURL);
  }

  public getTargetURL() {
    return this.targetURL;
  }

  public cleanIdCardFlags() {
    this.isIdCardSaved = false;
  }

  public setIsIdCardSaved() {
    this.isIdCardSaved = true;
  }

  doPushAccountValidation(params) {
    // alert('In doPushAccountValidation native integartion service')
    if (params.indexOf('deeplink') !== -1) {
      //   alert('index.html#' + paramValue)
      var paramValue = this.getParamValue(params, 'deeplink');
      if (paramValue) {
        // alert('paramValue');
        window.location.href = 'index.html#' + paramValue;
      }
    }
  }

  doMemberAudit(transactionTypeCode: string, successInd: boolean, errorCode?: string, additionalInfo?: any) {
    const httpOptions = {
      headers: this.setHeaders()
    };

    const memberAuditRequest = new MemberAuditRequest();

    memberAuditRequest.accountId = this.userSession.getCurrentAccountId();
    memberAuditRequest.transactionTypeCode = transactionTypeCode;
    memberAuditRequest.transactionSuccessInd = successInd;
    memberAuditRequest.transactionErrorCode = errorCode;
    memberAuditRequest.additionalInfo = additionalInfo || {};

    // There is no point to return anything with aduit service.
    this.post(memberAuditUrl, memberAuditRequest, httpOptions).subscribe();
  }

  getDeeplinkURLFromNative(params) {
    //  alert('In native integration service');
    console.log('In native integration service');
    if (this.utilService.getNativeOS() === 'Android') {
      this.doMemberAudit('M.62.002', true, '0000', {
        auditTransactionTypeDescription: "Access deeplink from Android device"
      });

      this.userSession.setLocalStorageItem('deeplinkfromAndroid', true, { persists: true });
      if (params.search('/redirects/') != -1 && params != null && params != '') {
        let startIndex = params.indexOf('redirects');
        let lastIndex = params.lastIndexOf('/');
        let env = params.substring(startIndex + 10, lastIndex);
        //console.log("environemnt"+env);
        if (env != 'sitb' && env != 'sita' && env != 'dev' && env != 'tt')
          env = '';
        if (params.search('brnewsletter-attention') != -1 || params.search('brnewsletter-reminder') != -1 || params.search('brnewsletter-welcome') != -1 || params.search('bluerewards') != -1) {
          params = 'https://member' + env + '.carefirst.com' + environment.applicationRoot + '/#/bluerewards/home';
          this.deeplinkName = 'Blue Reward Deeplink';
        }
        else if (params.search('billing') != -1) {
          let extractedUrl = params.substring(lastIndex + 1, params.length);
          let billingUrl = extractedUrl.split('-');
          params = 'https://member' + env + '.carefirst.com' + environment.applicationRoot + '/#/' + billingUrl[0] + '/' + billingUrl[1];
          this.deeplinkName = 'Billing Deeplink';
        }
        else if (params.search('cob') != -1 || params.search('registration') != -1) {
          let extractedUrl = params.substring(lastIndex + 1, params.length);
          params = 'https://member' + env + '.carefirst.com' + environment.applicationRoot + '/#/' + extractedUrl + '/home';
          this.deeplinkName = 'Registration Deeplink';
        }
        else if (params.search('tinforms') != -1) {
          params = 'https://member' + env + '.carefirst.com' + environment.applicationRoot + '/#/' + 'viewform/tinforms';
          this.deeplinkName = 'Tin Forms Deeplink';
        }
        else if (params.search('IDCard') != -1) {
          params = 'https://member' + env + '.carefirst.com' + environment.applicationRoot + '/#/' + 'idcards/home';
          this.deeplinkName = 'ID Cards Deeplink';
        }
        else if (params.search('planadvisor') != -1) {
          params = 'https://member' + env + '.carefirst.com' + environment.applicationRoot + '/#/' + 'planadvisor';
          this.deeplinkName = 'Plan Advisor Deeplink';
        }
        else if (params.search('eob') != -1) {
          params = 'https://member' + env + '.carefirst.com' + environment.applicationRoot + '/#/' + 'claims/listing/eob';
          this.deeplinkName = 'EOB Deeplink';
        }

        ga('myTracker.send', 'event', 'App Interaction', 'Click: Deeplink', this.deeplinkName);
        // if (typeof this.ga.submitEventToGA === 'function') {
        //   this.ga.submitEventToGA('Click: Deeplink',  this.deeplinkName);
        // }

      }
      else {

        if (params.search('https://www.carefirst.com/myaccount') != -1)
          params = ' https://member.carefirst.com' + environment.applicationRoot + '/';
      }
    }
    // if (this.utilService.getNativeOS() === 'Android') {
    if (this.utilService.getNativeOS() === 'iOS') {
      //    alert('In native integration service for IOS condition');
      console.log('In native integration service for IOS condition');
      // this.auditService.audit
      // ('M.62.001', true, '0000', {              
      //   auditTransactionTypeDescription: "Access deeplink from iOS device"            
      // });
      this.doMemberAudit('M.62.001', true, '0000', {
        auditTransactionTypeDescription: "Access deeplink from iOS device"
      });
    }
    this.userSession.setLocalStorageItem('deeplinkUrl', params, { persists: true });
    //   alert('check the URL');
    //spliting the url to get the route param for redireection
    var paramsArray = params.split('#');
    var routeParam = paramsArray[paramsArray.length - 1];
    //   alert('routeParam');
    // alert(routeParam);
    window.location.href = 'index.html#' + routeParam; //navigating to new URL
  }

  getParamValue(params, key) {
    var paramValue = '';
    var paramsArray = params.split(',');
    var index = -1;
    for (var i = 0; i < paramsArray.length; i++) {
      if (paramsArray[i].indexOf(key) !== -1) {
        index = i;
        break;
      }
    }
    var specificParams = index !== -1 ? paramsArray[index] : '';
    if (specificParams) {
      var param = specificParams.split('-');
      if (param[0] && param[0] === key) {
        paramValue = param[1];
      }
    }
    return paramValue;
  }
  /** ID CARDS SAVED IN LOCAL PATH START**/
  public idCardsSaved(localPath, noOfIdCards, timeStamp) {
    let localPath1 = this.userSession.getLocalStorageItem('cPath');
    let noOfIdCards1 = this.userSession.getLocalStorageItem('cCount');
    let timeStamp1 = this.userSession.getLocalStorageItem('cDate');

    //$scope.blockui.value = false;
    this.setSavedIDCardsData(localPath1, noOfIdCards1, timeStamp1);

    this.userSession.removeLocalStorageItem('cPath');
    this.userSession.removeLocalStorageItem('cCount');
    this.userSession.removeLocalStorageItem('cDate');

    //$state.go($state.current, {}, { reload: false });
    // $location.path('/idcards/home');
  }

  deleteResponse(deleteSuccess) {
    // if response is true
    if (deleteSuccess) {
      this.setSavedIDCardsData(null, null, null);

      // reload page on delete for tablet alone.
      // if (this.utilService.getDeviceType() === 'tablet') {
      //   window.location.reload(false);
      // }
    } else {
      // alert('delete failed');
    }
  }
  passLocationToFDS(position) {
    fap.sendEvent('fapWrapper', 'showLocationFAPWrapper', { data: position });
  }

  //getting pcp details from native 
  comingBackFromSSO(arg01, arg02) {
    //alert('inside coming back from sso');
    localStorage.setItem('returnSCUrl', arg02);
    console.log('arg01=' + arg01);
    var query = arg01.split('?')[1];
    if (!query) {
      alert('Query Parameters are missing');
    }
    else {
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var equalIndex = vars[i].indexOf('=');
        var key = encodeURIComponent(decodeURIComponent(vars[i].substring(0, equalIndex)));
        var value = vars[i].substring(equalIndex + 1);
        if (key === 'sdContext') {
          this.sdContext = value;
        }
        if (key === 'secretKey') {

          localStorage.setItem('secretKey', value);
        }
        if (key === 'pcpid') {
          this.pcpid = value;
        }
        if (key === 'firstname') {
          this.firstname = value;
        }
        if (key === 'lastname') {
          this.lastname = value;
        }
        if (key === 'middleinitial') {
          this.middleinitial = value;
        }
        if (key === 'sapphire_provider_id') {
          this.sapphire_provider_id = value;
        }
        if (key === 'sapphire_location_id') {

          this.sapphire_location_id = value;
          //    alert(this.sapphire_location_id);
        }
        if (key === 'gender') {
          this.gender = value;
        }
        if (key === 'phoneNumber') {
          this.phoneNumber = value;
        }
        if (key === 'address1') {
          this.address1 = value;
        }
        if (key === 'city') {
          this.city = value;
        }
        if (key === 'state') {
          this.state = value;
        }
        if (key === 'zip') {
          this.zip = value;
        }
      }
    }
    this.pcpData = {
      providerID: this.pcpid,
      firstname: this.firstname,
      lastname: this.lastname,
      middleinitial: this.middleinitial,
      sapphire_provider_id: this.sapphire_provider_id,
      locationId: this.sapphire_location_id,
      gender: this.gender,
      phone: this.phoneNumber.replace(/[^0-9]+/g, ''),
      addressLine1: decodeURIComponent(this.address1),
      city: decodeURIComponent(this.city),
      stateCode: this.state,
      zipCode: this.zip,
      isInternalMedicine: '',
      isPediatrics: '',
      medicalPanelID: '',
      pcmhPlusIndicator: 'N',
      pcpModeName: this.userSession.getLocalStorageItem('context') === "DHMOPCP" ? 'General Dentist' : 'PCP',
    };

    this.pcpData.firstname = this.pcpData.firstname.replace(/['"{()}]/g, '');
    if (this.pcpData.middleinitial && this.pcpData.middleinitial !== 'undefined') {
      this.pcpData.providerName = decodeURIComponent(this.pcpData.firstname + ' ' + this.pcpData.middleinitial + ' ' + this.pcpData.lastname);
    }
    else {
      this.pcpData.providerName = decodeURIComponent(this.pcpData.firstname + ' ' + this.pcpData.lastname);
    }
    this.userSession.setLocalStorageItem("providerDetails", JSON.stringify(this.pcpData), { persist: true });
    console.log('providerDetails:' + this.userSession.getLocalStorageItem("providerDetails"))


    //   if(this.userSession.getLocalStorageItem('enrlMaintTransType') === 'NEWHIRE'){
    //     console.log('inside sd wrapper service open enrollment');
    //    if ( this.userSession.getLocalStorageItem('context') === 'DHMOPCP') {
    //      //alert('inside dental pcp')
    //this.router.navigate(['/enrollment/fadsddentalpcp/search']);
    //    }
    //    else {
    //       //alert('inside pcp');

    //       this.router.navigate(['/enrollment/fadsdpcp/search']);
    //    }
    //  }
    //  else{
    
    // alert('[NS]secretKey=' + localStorage.getItem('secretKey'));
    // alert('[NS]returnSCUrl=' + localStorage.getItem('returnSCUrl'));
    console.log('context=' + this.userSession.getLocalStorageItem('context'))
    if (this.userSession.getLocalStorageItem('context') === 'DHMOPCP') {
      console.log('inside dental pcp')
      this.router.navigate(['/fadsddentalpcp/search/request']);
    }
    if (this.userSession.getLocalStorageItem('context') === 'PCP') {
      console.log('inside pcp');
      this.router.navigate(['/fadsdpcp/search/request']);
    }
    if (this.sdContext === 'sharecare') {
      console.log('redirecting to sd search component');
      this.router.navigate(['/fadsdpublic/search/sharecare']);
    }
    if (this.sdContext === 'cvsminuteclinic') {
      console.log('redirecting to sd search component');
      this.router.navigate(['/fadsdpublic/search/cvsminuteclinic']);
    }
    // }

  }
  //////////////////////////
  private bindExternalCallFromNative() {
    //  alert('In bindExternalCallFromNative call ');
    window['externalCall'] = function (functionName, arg01, arg02, arg03) {
      console.log('externalCall invoked: ' + functionName + ' arg01 is ' + arg01);
      //alert(functionName);
      //alert(arg01);
      if (functionName === 'invokeAngularWithTargetURL') {
        console.log("arg 1 ...  " + arg01);
        this.setTargetURL(arg01);
        //alert('invokeAngularWithTargetURL');
        // alert(arg01);
        this.eventService.publish('Reload_Version.json');
      } else if (functionName === 'reDirectToLandingPage') {
        //alert('reDirectToLandingPage');
        this.router.navigate(['/landing']);
      } else if (functionName === 'sapphireSSO') {
        //alert(arg01);
        console.log('sapphire sso');
        this.comingBackFromSSO(arg01, arg02);
      }
      else if (functionName === 'redirectToPrelogin') {
        window.location.href = window.location.protocol + '//' +
          window.location.host + window.location.pathname + '/../assets/native-app-static/prelogin.html'
      }


      else if (functionName === 'reDirectToMosWeb') {
        // conditions added for MOS to MOSWeb redirection for Native App
        let paramsArray = arg01.split(',');
        console.log('inside external call - redirecttomosweb ' + paramsArray);
        this.userSession.setLocalStorageItem('touchIdAuth', paramsArray[1], { persist: true });
        this.userSession.setLocalStorageItem('biometricType', paramsArray[2], { persist: true });
        this.userSession.setLocalStorageItem('touchIdStatus', paramsArray[3], { persist: true });
        //let newTouchIdUser = this.userSession.getLocalStorageItem('newUser');
        if (paramsArray[4] != null) {
          this.userSession.setLocalStorageItem('newUser', paramsArray[4], { persist: true });
        } else {
          this.userSession.setLocalStorageItem('newUser', 'false', { persist: true });
        }
        this.userSession.setLocalStorageItem('touchid', paramsArray[6], { persist: true });
        if (paramsArray[6] === 'true') {
          this.userSession.setLocalStorageItem('isEnableTouchIDChecked', 'true', { persist: true });
        }
        this.loggingInUserName = paramsArray[7];
        this.loggingInPassword = paramsArray[8];
        this.userSession.setLocalStorageItem('loginUserName', paramsArray[7], { persist: true });
        this.userSession.setLocalStorageItem('loginPassword', paramsArray[8], { persist: true });
        this.userSession.setLocalStorageItem('enabledUserNormalLoginFlow', paramsArray[9], {
          persist: true
        });
        this.userSession.setLocalStorageItem('authenticationDone', paramsArray[10], {
          persist: true
        });
        this.userSession.setLocalStorageItem('isRememberMeChecked', paramsArray[11], {
          persist: true
        });
        this.userSession.setLocalStorageItem('compatible', paramsArray[12], { persist: true });
        console.log(
          'Step 11 ' +
          this.userSession.getLocalStorageItem('isRememberMeChecked') +
          ' and ' +
          this.userSession.getLocalStorageItem('isEnableTouchIDChecked')
        );
        let touchIdStatusFlag = this.userSession.getLocalStorageItem('touchIdStatus');
        if (
          this.userSession.getLocalStorageItem('isRememberMeChecked') === 'true' ||
          this.userSession.getLocalStorageItem('isEnableTouchIDChecked') === 'true'
        ) {
          let newTouchIdUser = this.userSession.getLocalStorageItem('newUser');
          let userName = this.userSession.getLocalStorageItem('loginUserName');
          let passWord = this.userSession.getLocalStorageItem('loginPassword');
          console.log(
            'Step 22 ' + newTouchIdUser + ',' + userName + ',' + passWord + ',' + touchIdStatusFlag
          );
          if (newTouchIdUser == 'true') {
            console.log('Step 33 invoking storenewUserCredentials');
            this.invokeNativeService(
              this.utilService.getNativeOS(),
              'storeNewUsersCredentials',
              userName + ',' + passWord + ',' + touchIdStatusFlag
            );
          } else {
            console.log('Step 33 invoking registerTouchID');
            this.invokeNativeService(
              this.utilService.getNativeOS(),
              'registerTouchID',
              userName + ',' + passWord + ',' + touchIdStatusFlag
            );
          }
        }
      } else if (functionName === 'compatibilityCheck') {
        // condition added for FaceID and TuchId compatibility for Native app
        //alert("compatible " + arg01 + " arg02 " + arg02 + " compatibilityCheck");
        this.userSession.setLocalStorageItem('compatible', arg01, { persist: true });
        this.userSession.setLocalStorageItem('authenticationDone', 'false', { persist: true });

        if (arg01 === 'true') {
          if (arg02 === 'touchID') {
            this.userSession.setLocalStorageItem('compatible', arg01, { persist: true }); //FaceId Implementation:Check compatibility for touchId sets true
          }
          if (arg02 === 'faceID') {
            this.userSession.setLocalStorageItem('compatible', arg02, { persist: true }); //FaceId Implementation:Check compatibility for FaceId paramTwo = touchID
          }
        }

        //console.log(" compatibilityCheck compatible  localstorge" + this.userSession.getLocalStorageItem('compatible'));
      } else if (functionName === 'touchIdEnabledStatus') {
        this.userSession.setLocalStorageItem('touchIdStatus', arg01, { persist: true });
        this.userSession.setLocalStorageItem('touchid', arg01, { persist: true });
        //console.log("native integration page set touchIdStatus true page no 269" +  arg01);
        //console.log("compatible  touchIdStatus" + this.userSession.getLocalStorageItem('touchIdStatus'));
      } else if (functionName === 'loginTouchIdEnabledUser') {
        let newUserNotRegisteredTouchID = this.userSession.getLocalStorageItem(
          'newUserNoTouhIdEnabled'
        );
        if (newUserNotRegisteredTouchID == 'true') {
          this.userSession.setLocalStorageItem('newUserNoTouhIdEnabled', 'false', {
            persist: true
          });
          //console.log("native integration page set newUserNoTouhIdEnabled false page no 275");
        }
        let newTouchIdUser = this.userSession.getLocalStorageItem('newUser');
        if (newTouchIdUser == 'true') {
          this.userSession.setLocalStorageItem('newUser', 'false', { persist: true });
        }
        this.userSession.setLocalStorageItem('touchid', true, { persist: true });
        this.userSession.setLocalStorageItem('touchIdStatus', 'true', { persist: true });
        this.userSession.setLocalStorageItem('isRememberMe', true, { persist: true });
        this.userSession.setLocalStorageItem('loginUserName', arg01, { persist: true });
        this.userSession.setLocalStorageItem('loginPassword', arg02, { persist: true });
        //console.log("loginTouchIdEnabledUser   " + " arg01  " + arg01 + " arg02 " + arg02);
        this.userSession.setLocalStorageItem('isEnableTouchIDChecked', 'true');
        this.userSession.setLocalStorageItem('isRememberMeChecked', 'true');
        this.userSession.setLocalStorageItem('loginCompletedTFStatus', 'true', { persist: true });
        this.router.navigate(['termsCondition/' + 'loginCompleted'], { replaceUrl: true });
      } else if (functionName === 'resultOfTouchIdAuthentication') {
        this.userSession.setLocalStorageItem('touchIdAuth', arg01, { persist: true });
        this.userSession.setLocalStorageItem('biometricType', arg02, { persist: true });
        this.userSession.setLocalStorageItem('authenticationDone', 'true', { persist: true });
        //console.log("native integration page set authenticationDone true page no 275");
        let myProfileflag = this.userSession.getLocalStorageItem('myProfileTouchIdEnabled');
        let idType =
          this.userSession.getLocalStorageItem('biometricType') === 'faceID'
            ? 'Face ID'
            : 'Touch ID';

        console.log(
          'resultOfTouchIdAuthentication myProfileflag ' + myProfileflag + ' arg01 ' + arg01
        );
        if (myProfileflag == 'true') {
          //MyProfile flow
          if (arg01 == 'true') {
            console.log('in result of Touch ID for my profile');
            //this.userSession.setLocalStorageItem("myProfileTouchIdEnabled", "false");
            //this.router.navigate(['/profile/changeFaceTouchId/' + 'nativeAccept']);
            this.userSession.setLocalStorageItem('urlKeyLogin', 'true', { persist: true });
            this.router.navigate(['termsCondition/' + 'ChangeTouchFaceTerms'], { replaceUrl: true });
          } else {
            //this.router.navigate(['/profile/changeFaceTouchId/' + 'nativeDecline']);
            this.router.navigate(['termsCondition/' + 'ChangeTouchFaceDecline'], { replaceUrl: true });
          }
        } else {
          // Login Flow
          console.log(
            'resultOfTouchIdAuthentication login flow  ' + myProfileflag + 'arg01 ' + arg01
          );
          // this.callFaceTouchTermsRef = this.modalService.show(TouchfaceidTermsConditionsComponent);
          if (arg01 == 'true') {
            console.log('in terms condition');
            //this.callFaceTouchTermsRef = this.modalService.show(TouchfaceidTermsConditionsComponent);
            //this.router.navigate(['termsCondition/' + 'login']);
            this.userSession.setLocalStorageItem('urlKeyLogin', 'true', { persist: true });
            this.router.navigate(['landing/' + 'login'], { replaceUrl: true });


          } else {
            //console.log("failed terms condition");
            this.router.navigate(['termsCondition/' + 'loginDeclineTerms'], { replaceUrl: true });
          }
        }

        //console.log("resultOfTouchIdAuthentication touchIdAuth" + this.userSession.getLocalStorageItem('touchIdAuth'));
        //console.log("resultOfTouchIdAuthentication biometricType" + this.userSession.getLocalStorageItem('biometricType'));
        //console.log("resultOfTouchIdAuthentication authenticationDone" + this.userSession.getLocalStorageItem('authenticationDone'));
      } else if (functionName === 'prepopulateTouchIdLoggedInUserInfo') {
        this.userSession.setLocalStorageItem('registeredUserId', arg01, { persist: true });
        console.log("in prepopulateUserID set value after prepopulateTouchIdLoggedInUserInfo " + arg01)
        if (this.userSession.getLocalStorageItem('touchIdStatus') == 'true') {
          console.log("set touchid status in prepopulateTouchIdLoggedInUserInfo")
          this.userSession.setLocalStorageItem('touchid', true, { persist: true });
          this.userSession.setLocalStorageItem('isRememberMe', true, { persist: true });
        }
        let touchIdEnabledUserId = this.userSession.getLocalStorageItem('registeredUserId');
        console.log("set touchIdEnabledUserId prepopulateTouchIdLoggedInUserInfo " + touchIdEnabledUserId)
        this.userSession.setLocalStorageItem('loginUserName', touchIdEnabledUserId ? touchIdEnabledUserId : null, { persist: true });
        this.userSession.setLocalStorageItem('loginPassword', null, { persist: true });
        this.userSession.setLocalStorageItem('theUserID', touchIdEnabledUserId, { persist: true });
        this.userSession.setLocalStorageItem('isRememberUserName', touchIdEnabledUserId, { persist: true });
        this.userSession.setLocalStorageItem('rememberMe', touchIdEnabledUserId, { persist: true });
        console.log("set isRememberUserName prepopulateTouchIdLoggedInUserInfo " + touchIdEnabledUserId);
      } else if (functionName === 'idCardsSaved') {
        // alert("Idcard save function called");
        functionName = functionName;
        let path = arg01;
        let count = arg02;
        let date = arg03;

        this.userSession.setLocalStorageItem('cPath', path);
        this.userSession.setLocalStorageItem('cCount', count);
        this.userSession.setLocalStorageItem('cDate', date);

        this.idCardsSaved('', '', '');
      } else if (functionName === 'checkIdCardResp') {
        functionName = functionName;
        this.userSession.setLocalStorageItem('cPath', arg01);
        this.userSession.setLocalStorageItem('cCount', arg02);
        this.userSession.setLocalStorageItem('cDate', arg03);

        this.localPath = arg01;
        this.noOfIdCards = parseInt(arg02);
        this.timeStamp = arg03;

        if (
          this.localPath &&
          this.localPath !== 'null' &&
          this.localPath !== '' &&
          this.noOfIdCards &&
          this.noOfIdCards !== 0 &&
          this.timeStamp &&
          this.timeStamp !== '' &&
          this.timeStamp !== 'null'
        ) {
          this.isIdCardSaved1.next(true);
        } else {
          this.isIdCardSaved1.next(false);
        }
        //console.log("isIdCardSaved ===="+this.isIdCardSaved);

        //this.checkIdCardFlow = true;

        this.userSession.removeLocalStorageItem('cPath');
        this.userSession.removeLocalStorageItem('cCount');
        this.userSession.removeLocalStorageItem('cDate');

        this.utilService.setNativeNetworkStatus(
          this.userSession.getLocalStorageItem('isDeviceOnline')
        );
        //console.log("network status ---- "+this.utilService.getNativeNetworkStatus());

        if (this.utilService.getNativeNetworkStatus()) {
          this.userInOfflineMode = false;
        } else {
          this.userInOfflineMode = true;
        }
        //console.log("Inside the checkIdCard resp end with this.userInOfflineMode = "+ this.userInOfflineMode);
      } else if (functionName === 'doPushAccountValidation') {
        functionName = functionName;
        var docId = arg01;
        this.doPushAccountValidation(docId);
      } else if (functionName === 'getDeeplinkURLFromNative') {
        this.getDeeplinkURLFromNative(arg01);
      }
      else if (functionName === 'showLocation') {
        functionName = functionName;
        let lat = arg01;
        let lng = arg02;

        let currentState = this.router.url;
        // alert(lat);
        // alert(lng);
        this.userSession.setLocalStorageItem('lat', arg01, { persist: true });
        this.userSession.setLocalStorageItem('lng', arg02, { persist: true });

        if (currentState.includes('fad')) {
          // alert('inside include');
          this.passLocationToFDS(lat + ',' + lng);
          // alert(lat);
          // alert(lng);

        }
      }

    }.bind(this);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/native-integration.service.ts